<script lang="ts">
  import { i18n } from '../../util/i18n/i18n';

  export let category: string;
</script>

<fieldset class="category">
  <legend>{i18n('feedback.dialog.category.title')}</legend>
  <label class="category-item" class:selected={category === 'show'}>
    {i18n('feedback.dialog.category.show')}
    <input type="radio" value="show" bind:group={category} />
  </label>
  <label class="category-item" class:selected={category === 'teknisk'}>
    {i18n('feedback.dialog.category.techincal')}
    <input type="radio" value="teknisk" bind:group={category} />
  </label>
  <label class="category-item" class:selected={category === 'annet'}>
    {i18n('feedback.dialog.category.other')}
    <input type="radio" value="annet" bind:group={category} />
  </label>
</fieldset>

<style>
  .category {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    border: none;
  }

  legend {
    font-size: 1rem;
  }

  .category-item {
    background-color: var(--color-alternative-bg-hover);
    color: inherit;
    padding: 0.5rem 1rem;
    text-transform: uppercase;
    font-weight: 800;
    text-shadow: 1px 1px 0px var(--color-bg);

    /* border-radius: 9999px; */
    display: flex;
    justify-content: center;
    margin: 0 0.25rem;
    transition: all 0.1s ease-in-out;
  }

  .category-item:active {
    transform: scale(0.95);
  }

  .selected {
    background-color: var(--color-feedback-checked-emoji-bg);
    color: white;
  }

  input {
    pointer-events: none;
    position: absolute;
    height: 0;
    width: 0;
    opacity: 0;
  }
</style>
